import { ResourceType } from 'Enums/ResourceType';
import { ResourceThumbnail } from 'Enums/ResourceTypeThumbnails';

export const GetResourceTypeThumbnail = (resourceTypeID: number) =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  ResourceThumbnail[ResourceType[resourceTypeID]];
